import { SpecialZoneType } from './types';

export type CameraZoneField =
  | 'deadZones'
  | 'vehicleParkingZones'
  | 'activeZones';

export interface ZoneTypeConfig {
  type: SpecialZoneType;
  overlayName: string;
  toolbarLabel: string;
  iconColor: string;
  cameraField: CameraZoneField;
  borderColor: string;
  textColor: string;
  activeBgColor: string;
  activeTextColor: string;
}

export const ZONE_TYPE_CONFIGS: ZoneTypeConfig[] = [
  {
    type: SpecialZoneType.DeadZone,
    overlayName: 'Dead Zones',
    toolbarLabel: 'Dead Zone',
    iconColor: 'text-onlight-text-2 dark:text-ondark-text-2',
    cameraField: 'deadZones',
    borderColor:
      'border-onlight-text-2 dark:border-ondark-text-2 hover:border-onlight-text-1 dark:hover:border-ondark-text-1',
    textColor: 'text-onlight-text-1 dark:!text-ondark-text-1',
    activeBgColor: 'bg-onlight-text-2/50 dark:bg-ondark-bg-3',
    activeTextColor: '',
  },
  {
    type: SpecialZoneType.VehicleParkingZone,
    overlayName: 'Vehicle Parking Zones',
    toolbarLabel: 'Parking Zone',
    iconColor: 'text-primary-500',
    cameraField: 'vehicleParkingZones',
    borderColor: 'border-primary-500 hover:border-primary-600',
    textColor: '!text-primary-500',
    activeBgColor: 'bg-primary-100 dark:bg-primary-900',
    activeTextColor: 'text-primary-700 dark:text-primary-300',
  },
  {
    type: SpecialZoneType.ActiveZone,
    overlayName: 'Active Zones',
    toolbarLabel: 'Active Zone',
    iconColor: 'text-orange-500',
    cameraField: 'activeZones',
    borderColor: 'border-orange-500 hover:border-orange-600',
    textColor: '!text-orange-500',
    activeBgColor: 'bg-orange-100 dark:bg-orange-900',
    activeTextColor: 'text-orange-700 dark:text-orange-300',
  },
];
